import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Routes, Route, useNavigate } from "react-router-dom";
import { MdOutlineCancel } from "react-icons/md";
import Navigation from "./components/Navigation/Navigation";
import Catalogue from "./components/Catalogue/Catalogue";
import SearchRedirect from "./components/SearchRedirect/SearchRedirect";
import NotFound from "./components/NotFound/NotFound";
import Breadcrumbs from "./components/Breadcrumbs/Breadcrumbs";
import { breadcrumbNodesUpdated } from "./redux/reducer";
import { AppContext } from "./context/appContext";
import "./App.scss";
import SourceView from "./components/SourceView/SourceView";
import PointingSourcesView from "./components/PointingSourcesView/PointingSourcesView";
import TopHeader from "./components/TopHeader/TopHeader";
import { REGEXSEARCHURLPATHNAME } from "./RegEx";
import BulkRefresh from "./components/BulkRefresh/BulkRefresh";

function App() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { breadcrumbNodes } = useSelector((state) => state.router);
  const [flyoutMessage, setFlyoutMessage] = useState("");
  const [loaderVisible, setLoaderVisible] = useState(false);
  const RegExForSearchPathName = new RegExp(REGEXSEARCHURLPATHNAME);
  let isSearchPageURL = RegExForSearchPathName.test(window.location.pathname);

  function triggerNavigation(node, index, totalNodes) {
    if (index === totalNodes - 1) {
      return;
    }
    if (index >= 1 && index < totalNodes - 1) {
      navigate(index - (totalNodes - 1));
      dispatch(
        breadcrumbNodesUpdated({
          breadcrumbNodes: breadcrumbNodes.slice(0, index + 1),
        })
      );
    }
    if (index === 0) {
      window.location.href = node.absolute_path;
    }
  }

  return (
    <AppContext.Provider
      value={{
        flyoutMessage: "",
        showFlyout: (message) => {
          setFlyoutMessage(message);
          setTimeout(() => setFlyoutMessage(""), 5000);
        },
        loaderVisible: false,
        toggleLoaderVisibility: (isVisible) => setLoaderVisible(isVisible),
      }}
    >
      <Navigation />
      {!isSearchPageURL && (
        <TopHeader
          nodes={breadcrumbNodes}
          triggerNavigation={triggerNavigation}
        />
      )}
      <Routes>
        <Route path="release">
          <Route
            path="catalogue/:catalogueMetadataId"
            element={<Catalogue />}
          />
          <Route
            path="catalogue/:catalogueMetadataId/bulkupload"
            element={<BulkRefresh />}
          />
          <Route
            path="catalogue/:catalogueMetadataId/pointing/:pointingId/sources"
            element={<PointingSourcesView />}
          />
          <Route path="catalogue/:catalogueMetadataId/source-detail/:sourceId" element={<SourceView />} />
          <Route path=":relCatName/search" element={<SearchRedirect />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
      {flyoutMessage ? (
        <div className="flyout">
          {flyoutMessage}{" "}
          <button onClick={() => setFlyoutMessage("")}>
            <MdOutlineCancel />
          </button>
        </div>
      ) : (
        ""
      )}
      {loaderVisible ? (
        <div className="loader">
          <svg className="spinner" viewBox="0 0 50 50">
            <circle
              className="path"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              strokeWidth="5"
            ></circle>
          </svg>
        </div>
      ) : (
        ""
      )}
    </AppContext.Provider>
  );
}

export default App;
